import React from 'react';

export interface TableRow {
  label?: string;
  token?: string;
  amount?: string;
  value: string;
  infoIcon?: React.ReactNode;
  valueClass?: string;
  labelClass?: string;
  tooltip?: string;
}

interface TableWidgetProps {
  rows: TableRow[];
  className?: string;
  showLabelColumn?: boolean;
  showTokenColumn?: boolean;
  showAmountColumn?: boolean;
  columnHeaders?: {
    label?: string;
    token?: string;
    amount?: string;
    value?: string;
  };
}

export const TableWidget: React.FC<TableWidgetProps> = ({ 
  rows, 
  className = '', 
  showLabelColumn = true,
  showTokenColumn = true,
  showAmountColumn = true,
  columnHeaders = {
    label: 'Label',
    token: 'Token',
    amount: 'Amount',
    value: 'Value'
  }
}) => {
  if (rows.length === 0) {
    return (
      <div className={`table-widget empty ${className}`}>
        <p className="empty-message">No data available</p>
      </div>
    );
  }

  return (
    <div className={`table-widget ${className}`}>
      <table className="widget-table">
            <thead>
              <tr>
                {showLabelColumn && <th className="col-label">{columnHeaders.label}</th>}
                {showTokenColumn && <th className="col-token">{columnHeaders.token}</th>}
                {showAmountColumn && <th className="col-amount">{columnHeaders.amount}</th>}
                <th className="col-value">{columnHeaders.value}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {showLabelColumn && (
                    <td className={`col-label ${row.labelClass || ''}`}>
                      {row.label}
                      {row.infoIcon && <span className="info-icon-container">{row.infoIcon}</span>}
                    </td>
                  )}
                  {showTokenColumn && <td className="col-token">{row.token}</td>}
                  {showAmountColumn && <td className="col-amount">{row.amount}</td>}
                  <td className={`col-value ${row.valueClass || ''}`}>
                    {row.value}
                    {row.infoIcon && !showLabelColumn && <span className="info-icon-container">{row.infoIcon}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
      </table>
    </div>
  );
};
